import { render, staticRenderFns } from "./Theme2Gallery.vue?vue&type=template&id=6ebb948e&scoped=true&"
import script from "./Theme2Gallery.vue?vue&type=script&lang=js&"
export * from "./Theme2Gallery.vue?vue&type=script&lang=js&"
import style0 from "./Theme2Gallery.vue?vue&type=style&index=0&id=6ebb948e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebb948e",
  null
  
)

export default component.exports